// extracted by mini-css-extract-plugin
export default {"searchInput":"aRjQPlwfz3vGMz7mBRqc__searchInput___","loadingSkeleton":"nYyUqefH940PkopA2mxA__loadingSkeleton___"};